<template>
    <div class="field-checkbox field-wrap">
        <input :id="id" v-model="simpleFieldModel" type="checkbox" class="field-checkbox__input" />
        <label :for="id" class="field-checkbox__label">
            <span class="field-checkbox__pseudo-checkbox"></span>
            <template v-if="label">{{ label }}</template>
        </label>
    </div>
</template>

<script>
import { getRandomId } from '@/helpers/utils';
import { SimpleFieldMixin } from '@/mixins/SimpleFieldMixin';

export default {
    data() {
        return {
            id: getRandomId()
        };
    },
    components: {},
    mixins: [SimpleFieldMixin],
    props: {}
};
</script>
